import { Platform } from '../interfaces/event'

export const SERVICE_OFFER_PAGE_VIEWED_EVENT_DELAY = 1000
export const EVENT_COLLECTOR_END_POINT = '/event-collector/commands/emit-events/execute'

export const PlatformStringToEnum: Record<string, Platform> = {
  IOS: Platform.IOS,
  ANDROID: Platform.Android,
}
